<template>
  <div class="layout">
    <layout-left v-if="route.meta.isShowLeftSider"></layout-left>
    <Layout :style="{marginLeft: layoutMarginLeft + 'px'}">
      <layout-header v-if="route.meta.isShowHeader">
        <div v-if="route.meta.name" class="layout-header-bar">
          <div class="light-line"></div>
          {{route.meta.name}}
        </div>
        <div class="layout-header-user">
          <span
            style="margin-right:20px ;position: relative;text-align: center"
            @click="messageCenter"
          >
            <Icon type="ios-notifications-outline" :size="30" />
            <span class="messageNumber">{{ messageNum1 }}</span>
          </span>
          <Dropdown @on-click="onDropdownItemClick" class="username">
            <span href="javascript:void(0)">
              {{userData.username}}
              <Icon type="md-arrow-dropdown" />
            </span>
            <DropdownMenu slot="list">
              <DropdownItem name="password">修改密码</DropdownItem>
              <DropdownItem name="logout">退出</DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </div>
      </layout-header>
      <Content>
        <router-view
          :style="{overflow:'auto', zIndex: 0,width: viewWidth + 'px', height: viewHeight + 'px', backgroundColor: 'rgba(249, 249, 249, 1)'}"
        ></router-view>
      </Content>
    </Layout>
  </div>
</template>

<script>
import { post } from "@/libs/http/request";
import LayoutLeft from "./layout-left.vue";
import LayoutHeader from "./layout-header.vue";
import Emitter from "@/mixins/emitter.js";
import bus from "../../bus";
export default {
  name: "SiLayout",
  mixins: [Emitter],
  data() {
    return {
      LayoutHeaderHeight: 50, // 50
      layoutMarginLeft: 200,
      viewWidth: 0,
      viewHeight: 0,
      windowWidth: window.innerWidth,
      windowHeight: window.innerHeight,
      type: 0,
      userData: JSON.parse(window.localStorage.getItem("userData")),
      username: "",
      messageNum: "",
    };
  },
  created() {
    window.addEventListener(
      "resize",
      () => {
        this.windowWidth = window.innerWidth;
        this.windowHeight = window.innerHeight;
      },
      false
    );
    this.computedStyle();
  },
  watch: {
    windowWidth(val) {
      this.computedStyle();
    },
    windowHeight(val) {
      this.computedStyle();
    },
    route(val) {
      this.computedStyle();
    },
  },
  computed: {
    path() {
      return this.$route.path;
    },
    route() {
      return this.$route;
    },
    user() {
      return this.$store.state.user;
    },
    messageNum1() {
      return this.messageNum;
    },
  },
  mounted() {
    let that = this;
    bus.$on("USER_DATA", function (params) {
      that.userData = params;
    });
    this.getMessageData();
    setInterval(() => {
      this.getMessageData1();
    }, 60000);
  },
  components: {
    LayoutLeft,
    LayoutHeader,
  },
  methods: {
    onDropdownItemClick(name) {
      if (name === "logout") {
        post("api/managerExtends/logout", {}, (res) => {
          if (res == 0) {
            localStorage.removeItem("userData");
            localStorage.removeItem("password");
            this.$store.dispatch("CLEAR_USER_CACHE");
            // let exdate = new Date(); //获取时间
            // exdate.setTime(exdate.getTime()); //保存的天数
            // window.document.cookie =
            //   "autoLogin=false" + ";path=/;expires=" + exdate.toGMTString();
            this.$router.push("/");
          }
        });
      } else if (name === "password") {
      }
    },
    messageCenter() {
      this.$router.push({ path: "/MessageCenter/list" });
    },
    computedStyle() {
      let route = this.route;
      let meta = route.meta;
      let windowWidth = this.windowWidth;
      let windowHeight = this.windowHeight;
      if (meta.isShowLeftSider) {
        this.layoutMarginLeft = 200;
        this.viewWidth = windowWidth - this.layoutMarginLeft;
      } else {
        this.layoutMarginLeft = 0;
        this.viewWidth = windowWidth;
      }
      if (meta.isShowHeader) {
        this.viewHeight = windowHeight - this.LayoutHeaderHeight;
      } else {
        this.viewHeight = windowHeight;
      }
    },
    handleRefresh() {
      window.location.reload();
    },
    getMessageData(id) {
      let param = {
        templeMessage: {
          status: "未读",
        },
      };
      post("/api/templeMessage/count", param, (res) => {
        this.messageNum = res;
      });
    },
    getMessageData1() {
      let param = {
        templeMessage: {
          status: "未读",
        },
      };
      post("/api/templeMessage/count", param, (res) => {
        this.messageNum = res;
      });
    },
  },
};
</script>

<style lang="less" scoped>
.messageNumber {
  position: absolute;
  background-color: red;
  color: #ffffff;
  border-radius: 5px;
  width: 20px;
  height: 17px;
  line-height: 17px;
  left: 14px;
  bottom: 50%;
}
.layout {
  height: 100%;
  width: 100%;
  margin: 0;
  padding: 0;
  border: 1px solid #d7dde4;
  background: #f5f7f9;
  position: relative;
  border-radius: 4px;
  overflow: hidden;
  .message-list-bar {
    position: fixed;
    background: #ffffff;
    border: solid 4px #e4e4e4;
    bottom: 40px;
    left: 200px;
    width: 200px;
    height: auto;
    padding: 10px;
    text-align: center;
  }
}
.layout-header-user {
  float: right;
  margin-right: 30px;
  position: relative;
  bottom: 15px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Layout/layout.vue